import styled from 'styled-components';

export const Error = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;

  > div {
    > svg {
      margin-right: 5px;
    }
    padding: 5px 10px;
    width: 100%;
    background: rgb(150, 0, 0);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    font-size: 14px;
  }
`;


export const ContainerResearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: flex-start;
  width: 100%;

  .emojiList{
    @media (max-width: 750px) {
    width: 308px !important;
  }
  }

  button{
    @media (max-width: 750px) {
      margin-top: 5px !important;
      margin-bottom: 5px !important;
      padding: 10px !important;
      font-size: 14px !important;
    }
  }
 
  .researchTitle{
    width: 100%;
    text-align: center;
    font-size: 18px !important;
    p,strong,span,label{
    font-size: 18px !important;
    color: #333;

 



  }

  @media (max-width: 750px) {
    font-size: 14px !important;
    p,strong,span,label{
    font-size: 14px !important;
    color: #333;

 



  }
  }


  }
 .researchDescription{
  font-size: 14px !important;

  width: 100%;
    text-align: center;

  p,strong,span,label{
    font-size: 14px !important;
    color: #333;
  }

  @media (max-width: 750px) {
    font-size: 12px !important;
    p,strong,span,label{
    font-size: 12px !important;
    color: #333;

 



  }
  }


 }

 .markedPosition{
    
    color: #fff !important;
  }

`;
